import {
  PAGE_ROUTE_MEMBERSHIP,
  PORTAL_PREFIX,
  routePathWithoutLocale
} from "@kivunova/kivufrontendcommon";

/** Portal or membership — never login, registration, or marketing. */
export const isAuthenticatedAppRoute = (pathname: string): boolean => {
  const routePath = routePathWithoutLocale(pathname);
  return (
    routePath === PORTAL_PREFIX ||
    routePath.startsWith(`${PORTAL_PREFIX}/`) ||
    routePath === PAGE_ROUTE_MEMBERSHIP ||
    routePath.startsWith(`${PAGE_ROUTE_MEMBERSHIP}/`)
  );
};
